import React from 'react';

import {Button, Stack, Typography} from "@mui/material";
import FlexGrid from "../flexGrid/FlexGrid";
import ISnackModal from "../ISnackModal/ISnackModal";
import IModal from "../Modal/IModal";


const ImageDeleteModal = (open = false, close = undefined, deleteFunc = undefined) => {
    return (
        <IModal keepMounted open={open} showClose handleClose={close}>
            <Stack>
                <Typography>
                    Do you want to remove?
                </Typography>
                <FlexGrid>
                    <Button onClick={() => {
                        deleteFunc();
                        close()
                    }}>
                        Ok
                    </Button>
                    <Button onCLick={close}>
                        Cancel
                    </Button>
                </FlexGrid>
            </Stack>
        </IModal>
    );
};

export default ImageDeleteModal;